// Message types to / from worker clients
const messages = {
  ADD_ITEM_TO_LIST: 'add-item-to-list',
  AUTH_UPDATED: 'authorization-updated',
  BACKEND_NEEDS_UPDATE: 'backend-update',
  CREATE_DEFAULT_LIST: 'create-default-list',
  COUNT_LISTS: 'count-lists',
  COUNT_LIST_ITEMS: 'count-list-items',
  DELETE_LIST: 'delete-list',
  ITEM_STATUS: 'item-status',
  LOAD_LIST: 'load-list',
  LOAD_LIST_ITEMS: 'load-list-items',
  LOAD_LISTS: 'load-lists',
  REMOVE_ITEM_FROM_LIST: 'remove-item',
  SAVE_LIST: 'save-list',
  STORAGE_UPDATED: 'storage-updated',
  WORKER_READY: 'worker-ready'
}

export {
  messages
}